module.exports = __webpack_public_path__ + "img/ring_r_l_1_1@2x.a06b95d7.png";